import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { DistributionsCatalog } from "@/interfaces/v2Analytics";

export interface DistributionsCatalogState {
  /**
   * The distribution picker catalog from the bootstrap embed
   * (`clients[0].distributions`). null until bootstrap resolves, or when
   * the embed is disabled server-side / the user has no market footprint —
   * the Profile visualization is hidden in that case.
   */
  catalog: DistributionsCatalog | null;
}

const initialState: DistributionsCatalogState = {
  catalog: null,
};

const distributionsCatalogSlice = createSlice({
  name: "distributionsCatalog",
  initialState,
  reducers: {
    setDistributionsCatalog: (
      state,
      action: PayloadAction<DistributionsCatalog | null>,
    ) => {
      state.catalog = action.payload;
    },
  },
});

export const { setDistributionsCatalog } = distributionsCatalogSlice.actions;
export default distributionsCatalogSlice.reducer;
